import { render, staticRenderFns } from "./FutureLayerNodeChrome.vue?vue&type=template&id=0c84b6cf&"
import script from "./FutureLayerNodeChrome.vue?vue&type=script&lang=ts&"
export * from "./FutureLayerNodeChrome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports